import { inject, Injectable } from '@angular/core';
import type { WindowRef } from '@technocom/ui/dialogs';
import { DialogCenterService } from '@technocom/ui/dialogs';
import { CaptchaComponent } from '@app/core/components/captcha/captcha.component';

export interface CaptchaResponse {
  code: string;
  captchaId: string;
}

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  lengthCaptcha = 6;

  protected dialogService = inject(DialogCenterService);

  showCaptchaDialog(): WindowRef {
    const dialog = this.dialogService.window({
      content: CaptchaComponent,
      modal: true,
      stretch: true,
      minHeight: 340,
      resizable: false,
      title: 'Проверка',

      keepContent: true,
      toolbar: [
        {
          id: 'accept',
          text: 'Отправить',
          themeColor: 'primary',
          disabled: true,
          click: () => {
            dialog.close({ code: instance.code, captchaId: instance.captchaId });
          },
        },
      ],
    });

    const instance = dialog.content.instance;

    instance.codeChanged.subscribe(code => {
      dialog.toolbar.get('accept').disabled = instance.code.length !== this.lengthCaptcha;
    });

    return dialog;
  }
}
